import React, { useEffect, useState } from 'react';

import fetchIkeaProductFeed from '../../../../helpers/ikea-product-feed/ikea-product-feed-helpers';
import { IkeaProductCard } from '../../../../helpers/ikea-product-feed/interfaces';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
import { CardProduct } from '../../../cards/card-product';
import ShowMore from '../../list-page/show-more';
import { useUser } from '@/providers/UserProvider';

interface IkeaProductFeedProps {
  dictionary?: ILibraryMeetingPlaceDictionary;
  node_locale: string;
  businessUnitCode: string;
  primaryLanguage?: string;
  pageName: string;
}

const IkeaProductFeed = ({
  dictionary,
  node_locale,
  businessUnitCode,
  primaryLanguage,
  pageName,
}: IkeaProductFeedProps) => {
  const _productSize = 4;
  const [currPage, setCurrPage] = useState(1);
  const [products, setProducts] = useState<IkeaProductCard[]>([]);
  const slicedProductList =
    products && products?.slice(0, _productSize * currPage);

  const { user } = useUser();

  useEffect(() => {
    const fetchProductsData = async () => {
      const fetchedProducts = await fetchIkeaProductFeed(
        node_locale,
        businessUnitCode,
        primaryLanguage || '',
        10,
      );
      setProducts(fetchedProducts);
    };

    fetchProductsData();
  }, [node_locale, businessUnitCode, primaryLanguage]);

  return (
    <>
      {products && products.length > 0 && (
        <div className="grid grid-cols-1 gap-5 pt-6 sm:grid-cols-2">
          {slicedProductList?.map((product, index) => (
            <CardProduct
              key={product.id}
              card={product}
              cardIndex={index}
              buyNowText={dictionary?.buyAtIkea}
              pageName={pageName}
              user={user}
            />
          ))}
        </div>
      )}
      {products.length > _productSize - 1 && (
        <ShowMore
          currentPage={currPage}
          maxNum={products.length}
          setPage={setCurrPage}
          pageSize={_productSize}
          ofString={dictionary?.of}
          showMoreString={dictionary?.showMore}
          showingString={dictionary?.showing}
          event="ikea-product-see-more"
          user={user}
        />
      )}
    </>
  );
};

export default IkeaProductFeed;
